export const LOADING = 'home.LOADING';
export const LOADED = 'home.LOADED';